import type { FC } from "react";
import { useThemeMode } from "../providers/theme/themeContext";
import { getTomanAnimatedLogoSrc } from "../utils/theme/logos";

interface TomanAnimatedLogoProps {
  height?: string | number;
  width?: string | number;
}

const TomanAnimatedLogo: FC<TomanAnimatedLogoProps> = ({ height = 200, width = 200 }) => {
  const { theme } = useThemeMode();

  return (
    <img
      draggable={false}
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      style={{ height, width }}
      src={getTomanAnimatedLogoSrc(theme)}
      alt="Animated Toman Logo"
    />
  );
};

export default TomanAnimatedLogo;
